import { render, staticRenderFns } from "./AprovacaoSolicitacaoItemContent.vue?vue&type=template&id=f4db71f0&"
import script from "./AprovacaoSolicitacaoItemContent.vue?vue&type=script&lang=js&"
export * from "./AprovacaoSolicitacaoItemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports